import React, { Component } from 'react';
import './audioPlayer.scss';
import { Play } from 'lucide-react';
import Button from '../../components/ComponentsV1/Button';

const convertTime = (time) => {
  let mins = Math.floor(time / 60);
  if (mins < 10) {
    mins = '0' + String(mins);
  }
  let secs = Math.floor(time % 60);
  if (secs < 10) {
    secs = '0' + String(secs);
  }

  return mins + ':' + secs;
};

export default class AudioPlayer extends Component {
  constructor(props) {
    super(props);
    this.audio = new Audio(this.props.src);
  }

  audioTemp = () => {
    const { src } = this.props;
    return `<div id="audio"
                        style="display: flex;
                        flex: 1;
                        justify-content: center;
                        align-items: center;
                        height: 100%;
                        background: #000;"
                    >
                        <audio controls autoPlay>
                            <source src=${src} type="audio/ogg" />
                        </audio>
                    </div>`;
  };

  playAudio = () => {
    var w = window.open();
    var html = this.audioTemp();
    w.document.body.innerHTML = html;
  };

  render() {
    return (
      <Button
        size='small'
        onClick={this.playAudio}
        title={
          <div className='tw-flex tw-items-center tw-gap-2'>
            <Play
              size={14}
              fill='white'
              color='white'
              className='hover:tw-opacity-80 tw-transition-opacity tw-duration-200 tw-ease-in-out tw-leading-none'
            />
            <span className='tw-font-medium tw-text-[1.3rem] tw-text-white tw-whitespace-nowrap tw-leading-none'>
              Play Audio
            </span>
          </div>
        }
      />
    );
  }
}
